import React from 'react';
import PropTypes from 'prop-types';

import WhyBuyItem from './WhyBuyItem';
import MoreAboutDealer from './MoreAboutDealer';

const WhyBuyItems = ({ items }) => {
	return (
		<div className="why-buy-items d-flex flex-wrap px-6 pb-6 pt-3">
			{items.map((item, index) => (
				<WhyBuyItem
					key={item.title}
					totalCount={items.length}
					count={index + 1}
					item={item}
				/>
			))}
			<MoreAboutDealer totalCount={items.length} />
		</div>
	);
};

WhyBuyItems.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default WhyBuyItems;
